template = require('./progressbar.html.slim')

angular.module('wbComponents').directive 'progressbar',
[  ->
  restrict: 'E'
  replace: true
  templateUrl: template

  link: ($scope, $el, $attrs) ->
    setWidth = (value) ->
      width = $scope.$eval value
      $scope.width = { width: "#{width}%" }

    $attrs.$observe 'data', setWidth
]
